// Arreglo para mantener las definiciones de las rutas
const helpRoutes = [
  { path: 'faq', name: 'FAQ', component: 'FAQ' },
  { path: 'glosario', name: 'Glosario', component: 'Glosario' },
  { path: 'contacto', name: 'Contacto', component: 'Contacto' },
  { path: 'guias', name: 'Guias', component: 'Guias' },
  { path: 'privacypolicy', name: 'PrivacyPolicy', component: 'PrivacyPolicy' },
  { path: 'videotutorial', name: 'VideoTutorial', component: 'VideoTutorial' },
  { path: 'actualizaciones', name: 'Actualizaciones', component: 'Actualizaciones' },
  { path: 'documentacion-detallada', name: 'DocumentacionDetallada', component: 'DocumentacionDetallada' },
  { path: 'acerca-de', name: 'AcercaDe', component: 'AcercaDe' },
];

// Genera dinámicamente las rutas a partir de las definiciones
const routes = helpRoutes.map(({ path, name, component }) => ({
  path: `/${path}`,
  name,
  // Importación dinámica para lograr la carga diferida de componentes de ruta
  component: () => import(`../views/ayuda/${component}.vue`)
}));

export default routes;
